const ENUM_SUPPLY_TYPE = [{ s_type: "OutWard" }, { s_type: "InWard" }]
const ENUM_NOTE_TYPE = [{ n_type: "CREDIT" }, { n_type: "DEBIT" }]
const ENUM_TRADE_TYPE = [{ t_type: "RD" }, { t_type: "URD" }, { t_type: "OGS" }]
const ENUM_INVOICE_TYPE = [
  { value: "S", label: "S" },
  { value: "P", label: "P" },
  { value: "I", label: "I" },
  { value: "J", label: "J" },
]
const ENUM_CRDRNOTE_TYPE = [
  { value: "02-Post Sale Discount" },
  { value: "03-Deficiency in service" },
  { value: "04-Correction in invoice" },
  { value: "05-Change in POS" },
  { value: "06-Finalization of Provisional assessment" },
  { value: "07-Others" },
  { value: "TCS" },
  { value: "TDS" },
]
const ENUM_ROWS_FIELD = {
  acYear: "acYear",
  invType: "invType",
  invNo: "invNo",
  itemName: "itemName",
  printDetail: "printDetail",
  qty: "qty",
  rate: "rate",
  amount: "amount",
  discPer: "discPer",
  discAmt: "discAmt",
  stPer: "stPer",
  stAmt: "stAmt",
  astPer: "astPer",
  astAmt: "astAmt",
  netAmt: "netAmt",
}
const ENUM_INITIALROW = {
  acYear: 1,
  invType: "",
  invNo: "",
  itemName: "",
  printDetail: "",
  qty: 0,
  rate: 0,
  amount: 0,
  discPer: 0,
  discAmt: 0,
  stPer: 0,
  stAmt: 0,
  astPer: 0,
  astAmt: 0,
  netAmt: 0,
  detailId: 0,
}
function fun_calTcs_Amt(netAmount, tcsPer) {
  const amount = Number(netAmount);
  const percentage = Number(tcsPer);

  if (!Number.isFinite(amount) || !Number.isFinite(percentage)) {
    return "0.00";
  }

  return ((amount * percentage) / 100).toFixed(2);
}
function fun_calTotalTax(totalGstTax, totalSgstTax) {
  const gstTax = Number(totalGstTax);
  const sgstTax = Number(totalSgstTax);
  const safeGstTax = Number.isFinite(gstTax) ? gstTax : 0;
  const safeSgstTax = Number.isFinite(sgstTax) ? sgstTax : 0;
  return (safeGstTax + safeSgstTax).toFixed(2);
}
function fun_calTds_Amt(grossAmt, tdsPer) {
  const amount = Number(grossAmt);
  const percentage = Number(tdsPer);

  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const safePercentage = Number.isFinite(percentage) ? percentage : 0;

  return ((safeAmount * safePercentage) / 100).toFixed(2);
}


function toNumber(value) {
  return Number.isFinite(Number(value)) ? Number(value) : 0;
}

function fun_calNet_Amt(amount, discAmt, stAmt, astAmt) {
  const res =
    (toNumber(amount) - toNumber(discAmt)) +
    (toNumber(stAmt) + toNumber(astAmt));

  return Math.round(res);
}
export {
  ENUM_CRDRNOTE_TYPE,
  ENUM_INVOICE_TYPE,
  ENUM_NOTE_TYPE,
  ENUM_SUPPLY_TYPE,
  ENUM_TRADE_TYPE,
  ENUM_ROWS_FIELD,
  ENUM_INITIALROW,
  fun_calTotalTax,
  fun_calTds_Amt,
  fun_calNet_Amt,
  fun_calTcs_Amt,
}


